import common from "../../../../assets/js/common";
import { getLadderPrice } from '../../../../assets/js/price'
import group from "../group.vue";
import ordinary from "../ordinary.vue";
import spike from "../spike.vue";
import presale from "../presale.vue";
import yzqModal from "../yzqModal.vue";
import spikeModal from "../spikeModal.vue";

import { Component , Vue, Watch  } from 'vue-property-decorator';

@Component({
  components:{
    group,ordinary,spike,presale,yzqModal,spikeModal
  }
})
export default class goodsInfo extends Vue {
    //默认数据
    currentColor:any = {}//选定的颜色
    currentSpec:any = {}//活动商品选定的规格
    totalNum= 0 // 已选择的商品数量
    totalPrice= 0 // 已选择的商品总价格
    totalFavorableAmt=0 //优惠价格
    mainImg=''//显示图片路径
    showImgs:any = []//商品图片数组
    items = [{}]//已选商品信息
    listDesc=''//商品描述
    pageList=[]//同类热销商品
    //status='begin'//活动状态  pre  预告   begin 开始  end  结束
    yzqExplain=false//邮账期说明弹窗
    spikeCodeModal=false//秒杀验证码弹窗
    tag:any={}//标签值
    codeSrc:any=''//秒杀验证码
    spikeNum:Number=0 // 已秒数量
    activityStorge:Number=0//活动库存
    selectGoodsObj:any={}//商品itemId : 该规格商品数量
    selectGoodsActivity:any = {};//已选商品活动
    presellFlag :any =false;//是否预售
    groupFlag :any =false;//是否团购
    comboFlag :any =false;//是否套餐
    financeFlag :any =false;//金融专区

    get goodsData(){
      return this.$store.getters["collationData/getGoodsDetailData"];
    }

    //计算属性
    get beginNum(){//起订量
      return this.tag.beginNum || 1;
    }
    get limitNum(){//限购数量
      return this.tag.limitNum || 0;
    }
    get isBuyShow(){//是否显示立即购买按钮
      return true
    }
    get isActivity(){//是否计时活动
      if(this.tag[8300] || this.tag[8200] || this.tag[7070] ){//预售  团购  秒杀 套餐、邮账期没确定
        return this.tag[8300] || this.tag[8200] || this.tag[7070]
      }
      return false
    }
    get isAddCartShow(){//是否显示加购按钮
      if(this._activity.getActiveCode(this.goodsData)>0 && this.isActivity.state != 'pre')
        return false
      return true
    }

    created(){
      this.init();
    }

    //执行方法
    init(){
      this.goodsData.tagInfo = this.goodsData.tagInfo ? this.goodsData.tagInfo  : {}
      this.tag = this.goodsData.tagInfo;
      this.activityAlreadyBuy();
      if(this.goodsData.pxItemDtos.length == 1 && this.goodsData.pxItemDtos[0].itemStorage>this.beginNum){//单规格设置改规格商品起订量  
        this.goodsData.pxItemDtos[0].itemCount = this.beginNum;
      }
      if(this.tag[8300]){//预售
        this.presellFlag=true;
      }else if(this.tag[8200]){//团购
        this.groupFlag=true;
      }else if(this.tag[4040]){//套餐
        this.comboFlag=true
      }
      this.colorChoice(this.goodsData.colorInfo[0]);//初始化颜色
      this.total();
    }

    activityAlreadyBuy(){//秒杀   团购  限购  已购买数量
      let data:any={};
      if(this.tag[7070]){
        data[this.goodsData.listId] = '7070:' + this.tag[7070].activityId;
      }else if(this.tag[8200]){
        data[this.goodsData.listId] = '8200:' + this.tag[8200].activityId;
      }else if(this.tag[1900]){
        data[this.goodsData.listId] = '1900:' + this.tag[1900].activityId;
      }else{
        return false
      }
      this.fetch({ //接口wiki地址 http://wiki.uletm.com/pages/viewpage.action?pageId=36478237
        url: window.apis.activityAlreadyBuy,
        data: {itemTypeMap:data}
      }).then((res: any) => {
        if (this.tag[7070]) {
          for (const spike in res) {
            if (res.hasOwnProperty(spike)) {
              this.spikeNum += res[spike];
            }
          }
        }
      })
    }

    total(){//计算总数  总价
      this.totalNum=0;
      this.items=[];
      this.selectGoodsObj={};
      this.selectGoodsActivity={};
      this.goodsData.pxItemDtos.forEach((item:any) => {
        this.selectGoodsActivity[item.itemId]=[];
        this.totalNum += Number(item.itemCount);
        if(item.itemCount>0){//已选数量不为0  存入待提交数据
          let map ={
            itemId:item.itemId,
            listingId:this.goodsData.listId,
            itemCount:item.itemCount
          }
          this.items.push(map);
          this.selectGoodsActivity[item.itemId].push(this.tag.defActId);
          this.selectGoodsObj[item.itemId]=item.itemCount;
        }
      });
      getLadderPrice(this.goodsData,this.totalNum);//阶梯价商品价格判断
      this.totalPrice = this.goodsData.salePrice * this.totalNum;
    }
    colorChoice(color:any){//选择颜色
      this.currentColor = color;
      this.showImgs = common.arrSlice(this.currentColor.colorDisplayImg.split('|*|'),5,false);
      this.mainImg = this.showImgs[0][0];
      if(this.isActivity){
        for (let i = 0; i < this.goodsData.pxItemDtos.length; i++) {
          const el = this.goodsData.pxItemDtos[i];
          if(el.colorId == color.colorId){
            this.specChoice(el);
            break;
          }
        }
      }
    }
    specChoice(spec:any){//选择规格
      if(this.tag['7070'] && this.isActivity.state!='pre'){
        spec.itemCount = this.tag['7070'].limitNum;  
        this.activityStorge = spec.itemActivityStorage;
      }
      this.currentSpec = spec;
      this.goodsData.currentSpec = spec;
      this.$store.dispatch("updateDetailData",this.goodsData)
    }
    down(spec:any){//数量减
      if (this.tag[7070] && this.isActivity.state != 'pre') {
        return 
      }
      //单规格商品                        数量等于起订数量
      if(this.goodsData.pxItemDtos.length == 1 && spec.itemCount <= this.beginNum){
        spec.itemCount = this.beginNum;
      }else if(spec.itemCount>0){
        spec.itemCount--;
      }
      this.total();
    }
    add(spec:any){//数量加
      if (this.tag[7070] && this.isActivity.state != 'pre') {
        return 
      }
      //   限购商品           已选数量大于限购数量
      if(this.limitNum>0 && this.totalNum >= this.limitNum)
        return 
      spec.itemCount++;
      this.total();
    }
    inputChange(spec:any){//输入数量
      spec.itemCount = Number(spec.itemCount.replace(/[^\d]/g,0));
      if(this.goodsData.pxItemDtos.length == 1 && spec.itemCount < this.beginNum){
        spec.itemCount = this.beginNum;
      }
      this.total();
    }
    changeImg(img:any){//小图悬停切换大图
      this.mainImg = img;
    }
    specificationAddCart () {
      if (this.totalNum < this.beginNum) {
        this.$msgbox({ title: '提示', message: `商品数量不能小于起售数量【${this.beginNum}】` })
      }else if (this.limitNum > 0 && this.totalNum > this.limitNum) {
        this.$msgbox({ title: '提示', message: `商品数量不能大于限购数量【${this.beginNum}】` })
      } else {
        this.addCart();
      }
    }
    buy(accountPeriodFlag:any){//立即购买  是否账期购买
      if (this.totalNum<=0) {
        this.$msgbox({ title: '提示', message: `请选择商品的规格及数量` })
        return false
      }
      this.$router.push({name:"pxOrderConfirm" , params:{
        itemNumMap : this.selectGoodsObj , 
        activityMap:this.selectGoodsActivity ,
        presellFlag:this.presellFlag,
        groupFlag:this.groupFlag,
        comboFlag:this.comboFlag,
        financeFlag:this.financeFlag,
        accountPeriodFlag:accountPeriodFlag
      }})
    }
    
    spikeClick(){//秒杀抢购
      this.spikeCodeModal = true;
    }

    // 加入进货单
    addCart () {
      if (this.items.length < 1) {
        this.$message.error({
          message: "请添加商品数量",
          type: "error"
        });
        return false;
      }
      this.$store.dispatch('cart/addCartAsync', this.items).then(() => {
        this.$message({
          message: "已加入进货蓝",
          type: "success",
        });
      })
    }

    whatYzq(val:any){//什么是邮账期
      this.yzqExplain = val;
      console.log(yzqModal);
    }

}